import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

const TermsOfService = () => {
  return (
    <div className="min-h-screen bg-white flex flex-col">
      <Navbar />
      <main className="flex-1 max-w-4xl mx-auto w-full px-4 sm:px-6 lg:px-8 py-12">
        <h1 className="text-3xl font-heading font-bold text-foreground mb-6">Terms of Service</h1>
        <div className="space-y-5 text-sm text-muted-foreground leading-relaxed">
          <p>
            By using this site, you agree to use it lawfully and in a manner that does not interfere with service
            availability, security, or other users.
          </p>
          <p>
            All content is provided for informational purposes. Project terms, deliverables, and commercial details are
            governed by executed agreements.
          </p>
          <p>
            We may update these terms periodically. Continued use of the site after updates indicates acceptance of the
            revised terms.
          </p>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default TermsOfService;
